import { render, staticRenderFns } from "./StockViewTransferOrder.vue?vue&type=template&id=da09c460&scoped=true"
import script from "./StockViewTransferOrder.vue?vue&type=script&lang=js"
export * from "./StockViewTransferOrder.vue?vue&type=script&lang=js"
import style0 from "./StockViewTransferOrder.vue?vue&type=style&index=0&id=da09c460&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da09c460",
  null
  
)

export default component.exports